import React, { useContext, useEffect, useState } from "react";
import "../components/points/Points.scss";
import { Box, Typography, Button } from "@mui/material";
import Pnts from "../components/points/Pntsnew";
import { getResults, getsession } from "../utils/apis"; // ✅ import getsession
import { AuthContext } from "../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { KEY_BILLINGCITY } from "../utils/contants";
import { translation_hi } from "../translations/translation_hi";
import { translation_en } from "../translations/translation_en";

interface voucherProps {
  BtnReq?: boolean;
}

const Voucher: React.FC<voucherProps> = () => {
  // const { t } = useTranslation();
  function translate(obj: any, path: string) {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

// ✅ Choose translation based on saved language
const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = lang.startsWith("hi") ? translation_hi : translation_en;

// ✅ Define t() function that mimics react-i18next’s syntax
const t = (key: string) => translate(translations, key);

  const [BtnReq, setBtnReq] = useState<boolean>(false);
  const [pointsData, setPointsData] = useState<any>(null);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const decryptedId = id ? atob(id) : "";
  const billing_city = localStorage.getItem(KEY_BILLINGCITY) || null;

  useEffect(() => {
    const fetchData = async () => {
      if (authContext) {
        const { token }: any = authContext;
          const tokenn = localStorage.getItem("token");

        // ✅ Read location & notification consent
        const latitude = localStorage.getItem("latitude") || "";
        const longitude = localStorage.getItem("longitude") || "";
        const notificationConsent = localStorage.getItem("notification_consent_status") || "0";
        const locationConsent = localStorage.getItem("location_consent_status") || "0";
        const pageName = localStorage.getItem("page_name") || "unknown";

        try {
          // ✅ Console before calling getsession
          console.log("🚀 Calling getsession API with task_id:", decryptedId);

          // ✅ Call getsession API
          await getsession(
            decryptedId,
            navigator.userAgent,
            latitude,
            longitude,
            navigator.appVersion,
            navigator.appName,
            navigator.appVersion,
            notificationConsent,
            locationConsent,
            pageName,
            decryptedId
          );

          // ✅ Console after getsession resolves
          console.log("✅ getsession API call completed");

          // ✅ Call getResults API
          const data = await getResults(decryptedId, String(tokenn));
          setPointsData(data);
          setBtnReq(data.result_details.req_approval);
        } catch (error) {
          console.error("Failed to fetch data or session:", error);
        }
      }
    };
    fetchData();
  }, [authContext, decryptedId]);


  return (
    <Box sx={{ width: "100%" }}>
      <Pnts pointsData={pointsData} />
      <Box className="vouchers">
        {/* Voucher UI code */}
      </Box>
      <Box
        sx={{
          background: "linear-gradient(141deg, #282829 -0.06%, #620B17 97.43%)",
          textAlign: "start",
          padding: "32px 20px",
          marginBottom: "80px",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            letterSpacing: "-0.32px",
            color: "#FFF",
            maxWidth: "272px",
          }}
        >
          {t("rewards.title")}{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            color: "#C5C6C7",
            maxWidth: "272px",
            marginBottom: "20px",
          }}
        >
          {t("rewards.sub_title")}
        </Typography>
        <Button
          sx={{
            marginTop: "20px",
            background: "#C8172F",
            width: "100%",
            borderRadius: "8px",
            color: "#FFF",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "500",
            textTransform: "none",
            ":hover": { color: "#fff" },
          }}
          onClick={() => navigate("#")}
        >
          {t("rewards.view_all_reward")}
        </Button>
      </Box>
      <Box className="foot" sx={{ display: "flex", width: "100%" }}>
        {BtnReq && (
          <Button
            className="btn_trans"
            onClick={() =>
              window.parent.postMessage({ action: "redirectTo", label: "pmi-all-tasks" }, "*")
            }
          >
            {t("taskdetaitls.watch_videos.result.check_status")}
          </Button>
        )}
        <Button
          className="btn_red"
          onClick={() =>
            window.parent.postMessage({ action: "redirectTo", label: "points-history" }, "*")
          }
        >
          {t("taskdetaitls.watch_videos.result.go_to_home")}
        </Button>
      </Box>
    </Box>
  );
};

export default Voucher;